import { Typography } from "@mui/material";
import { TitumDetails } from "titum-layouts/shared-components/TitumDetails";
import footer from "../../Assets/footer.png";
import "./billfooter.css"
import { Box } from "@mui/system";

const BillFooter = () => {
  const dotFooter = JSON.parse(localStorage.getItem('bizx_location'))?.stockLocationDetail?.dotFooter;

  return (
    <>
      <div>
      
        <Box sx={{ marginLeft: 1, marginRight: 1, marginBottom:1}}>
          <div
            dangerouslySetInnerHTML={{ __html: dotFooter }} />
        </Box>        
        {/* <div className="col-12">
        <div style={{ fontSize:10, textAlign:"center"}}>You can now deposit to : A/C 185010001347 (HNB, Maruthamunai.)</div>
            <div
              style={{
                fontSize:10,
                textAlign: "center",
              }}
            >
              `{TitumDetails.SOLUTION_BY} | {TitumDetails.WEB} | {TitumDetails.EMAIL_ID}`
            </div></div> */}

       
      </div>
    </>
  );
};

export default BillFooter;